import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

import { withDefaults, computed, inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LzIcon',
  props: {
    name: {},
    source: { default: '/img/sprite.svg' }
  },
  setup(__props: any) {

const props = __props;


const prototype = inject('prototype');
const contextPath = inject('contextPath');

const sprite = computed(() => (prototype ? '' : '/.resources/rize/webresources') + props.source);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", null, [
    _createElementVNode("use", {
      "xlink:href": `${_unref(contextPath)}${sprite.value}#${_ctx.name}`,
      style: {"pointer-events":"none"}
    }, null, 8, _hoisted_1)
  ]))
}
}

})